import { UserLevel } from "../users";

export enum IUserRoleStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export const usersRoleStatusMap: Record<string, IUserRoleStatus> = {
  Active: IUserRoleStatus.ACTIVE,
  Inactive: IUserRoleStatus.INACTIVE,
};

export const usersRoleLevelMap: Record<string, UserLevel> = {
  Group: UserLevel.GROUP,
  Brand: UserLevel.BRAND,
  Branch: UserLevel.BRANCH,
};

export enum AssignedVariants {
  NONE = "NONE",
  ASSIGNED = "ASSIGNED",
}

export const usersAssignedMap: Record<string, AssignedVariants> = {
  None: AssignedVariants.NONE,
  Assigned: AssignedVariants.ASSIGNED,
};

export enum ActionsForRole {
  UPDATE = "update",
  READ = "read",
  NONE = "",
}

export enum AvailableSections {
  LIVE_TRANSACTION = "LiveTransactions",
  TRANSACTIONS_REPORT = "TransactionReports",
  OVERVIEW_DASHBOARD = "OverviewDashboard",
  FUNDING = "Funding",
  USERS = "Users",
}

export interface IUserRolePermissin {
  section: AvailableSections;
  action: ActionsForRole;
}

export interface IUserRole {
  id: string;
  name: string;
  level: UserLevel;
  assignedUsersCount: number;
  createdAt: string;
  updatedAt: string;
  active: boolean;
  isSystem: boolean;
  permissions: IUserRolePermissin[];
}

export interface ICreateUserRole {
  name: string;
  level: UserLevel;
  permissions: IUserRolePermissin[];
}

export interface IAssignmentsUserToRole {
  level: UserLevel;
  role: string;
  roleId: string;
  partnerIds: string[];
}

export interface IAssignmentsResponse {
  createdCount: number;
  createdPartnerIds: string[];
  skippedCount: number;
  skippedPartnerIds: string[];
}
